/** Пикселей в одной «строке» колеса, когда браузер считает прокрутку строками (Firefox). */
export const WHEEL_LINE_PX = 16;

type WheelLike = Pick<WheelEvent, 'deltaX' | 'deltaY' | 'deltaMode' | 'ctrlKey'>;

/**
 * Колесо над неподвижной частью панели (сцена, шапка, табы) листает тело панели.
 * Возвращает, на сколько пикселей сдвинуть тело, или null — событие не перехватывается:
 * жест масштаба (ctrl + колесо, щипок трекпада) и горизонтальная прокрутка (полоса табов).
 */
export function bodyWheelDelta(event: WheelLike, pageHeight: number): number | null {
  if (event.ctrlKey) return null;
  if (event.deltaY === 0 || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return null;
  if (event.deltaMode === 1) return event.deltaY * WHEEL_LINE_PX;
  if (event.deltaMode === 2) return event.deltaY * pageHeight;
  return event.deltaY;
}
